var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('input',{ref:"uploader",attrs:{"id":"uploader","type":"file"},on:{"change":_vm.onChange}}),_c('a-button',{attrs:{"loading":_vm.loading,"type":"primary"},on:{"click":_vm.onClick}},[_vm._v("导入 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }